import { ArrowRight, HardHat, Handshake, TreePine, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { SOCIAL_VALUE_CARDS } from "@/content/commercial/social-value";

export function CommercialSocialValue({
  showViewAllLink = false,
  viewAllHref = "/commercial-social-value",
  viewAllLabel = "View social value reporting",
}: {
  showViewAllLink?: boolean;
  viewAllHref?: string;
  viewAllLabel?: string;
}) {
  return (
    <section className="bg-primary text-primary-foreground py-14 md:py-20">
      <div className="container-page">
        <div className="max-w-3xl mb-8 md:mb-10">
          <div className="flex items-center gap-2 mb-3 text-accent">
            <Users className="h-5 w-5" aria-hidden />
            <p className="text-xs font-bold uppercase tracking-widest">Social Value</p>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold leading-tight">
            Reported In Your Format, Evidenced Per Project
          </h2>
          <p className="text-base md:text-lg text-primary-foreground/90 mt-3 leading-relaxed">
            Social value isn&apos;t an afterthought. It&apos;s agreed up front against your framework&apos;s
            measures and reported on completion, with the evidence to back it up.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {SOCIAL_VALUE_CARDS.map((c) => (
            <article
              key={c.title}
              className="rounded-2xl border border-white/15 bg-white/5 backdrop-blur-sm p-5"
            >
              <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center mb-3">
                <c.Icon className="h-5 w-5 text-accent" aria-hidden />
              </div>
              <h3 className="font-bold text-primary-foreground text-base mb-1.5">{c.title}</h3>
              <p className="text-sm text-primary-foreground/85 leading-relaxed">{c.body}</p>
            </article>
          ))}
        </div>
        {showViewAllLink && (
          <div className="mt-8">
            <a
              href={viewAllHref}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent hover:text-accent/80 transition-colors"
            >
              {viewAllLabel}
              <ArrowRight className="h-4 w-4" aria-hidden />
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
